export default "__VITE_ASSET__BKjuM1Mr__"